import type { CdwColDef } from '../interfaces/cdw-col-def.interface';

export const defaultCdwColDef: CdwColDef = {
  sortable: true,
  resizable: true,
  filter: false,
  maxWidth: 500,
  suppressMovable: false, // Enable column drag-and-drop reordering
};
